import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Breadcrumb } from '@e3dc-react/shell/Elements/Header/Breadcrumbs'
import { useNavigate } from 'react-router-dom'
import { InstallationForm } from '../components'
import { getDefaultInstallation } from '../../installation/forms'

const NewInstallationPage: React.FC<{ installationId?: string }> = ({ installationId }) => {
  const { t } = useCustomTranslation()
  const navigate = useNavigate()

  const breadcrumb: Breadcrumb = {
    title: t('framework.new-installation'),
    onClick: () =>
      installationId ? navigate(`/new-installation/${installationId}`, { relative: 'path' }) : navigate('/new-installation', { relative: 'path' }),
  }
  return <InstallationForm defaultValues={getDefaultInstallation(t)} parentBreadcrumb={breadcrumb} />
}

export default NewInstallationPage
